module.exports = __webpack_public_path__ + "img/ro.af4f1a84.svg";